import React, { Component } from 'react';

interface IProps {
  step?: number;
  variant?: 'player' | 'staff';
}
interface IState {
  completed: boolean;
}

class ProgressBar extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      completed: (props.step || 0) >= 3
    };
  }

  public shouldComponentUpdate(nextProps: IProps, nextState: IState): boolean {
    return this.props.step !== nextProps.step || this.state.completed !== nextState.completed;
  }

  public componentDidUpdate(): void {
    if ((this.props.step || 0) >= 3) {
      setTimeout(() => {
        this.setState({ completed: true });
      }, 1000);
    } else if (this.state.completed) {
      this.setState({ completed: false });
    }
  }

  public render(): JSX.Element {
    const step = this.props.step || 0;
    const completed = this.state.completed ? 'completed' : '';

    const stage = `step${step} ${completed}`;
    return (
      <div className={`progress-bar progress-bar--${this.props.variant || 'staff'} ${stage}`}>
        <div className="ball-wrapper">
          <div className="ball" />
        </div>

        <div className="circle circle1">
          <div className="check" />
        </div>
        <div className="line line1">
          <div className="fill" />
        </div>

        <div className="circle circle2">
          <div className="check" />
        </div>
        <div className="line line2">
          <div className="fill" />
        </div>

        <div className="circle circle3">
          <div className="check" />
        </div>
        <div className="line line3">
          <div className="fill" />
        </div>

        <div className="circle circle4" />
        <div className="flag" />
      </div>
    );
  }
}

export { ProgressBar };
